export const projects = [
  {
    title: "Frezio Movil",
    subtitle: "Lead Developer React Native/Node.js",
    description:
      "Frezio is mobile app which lets you control your AC, TV and more thing. Built with React Native and Node.js",
    image: "./frezio.png",
    link: "https://apps.apple.com/bo/app/frezio-movil/id1641980283?l=en",
  },
  {
    title: "Agrotratos Mobile",
    subtitle: "Lead Developer React Native",
    description:
      "Agrotratos is a agro-platform where users can offer their services or products.",
    image: "./agrotratos-mobile.png",
    link: "https://play.google.com/store/apps/details?id=com.agrotratosapp",
  },
  {
    title: "Agrotratos",
    subtitle: "Lead Ruby Developer",
    description:
      "Agrotratos is a agro-platform where users can offer their services or products.",
    image: "./agrotratos.png",
    link: "https://agrotratos.com.bo",
  },
  {
    title: "Agile Testing Fellow",
    subtitle: "Ruby on Rails Engineer",
    description:
      "ATF is a platform built for the courses given for Janet Gregory and Lisa Crispin, where fellows can take the assessment and get the certification.",
    image: "./atf-project.png", 
    link: "https://agiletestingfellow.com",
  },
  {
    title: "Folionet LLC",
    subtitle: "Senior Ruby Software Developer",
    description:
      "Folionet LLC is a fintech with its focus is Latam and they offer trading, selling and buying cryptos.",
    image: "./folio.png",
    link: "https://folionet.com",
  },
  {
    title: "trendig technology services GmbH",
    subtitle: "Senior Python/Ruby/React Native Developer",
    description:
      "Trendig has a lot of projects which they use by themselves, like: trendig.com, agiletestingdays.com and so on.",
    image: "./trendig.png",
    link: "https://trendig.com",
  },
  {
    title: "Meludus",
    subtitle: "Senior Python Developer",
    description:
      "Meludus is platform where students who want to get a public job can study with custom tests and Meludus offers to them many kinds of way to study.",
    image: "./meludus.png",
    link: "https://meludus.com",
  }
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "Ruby",
  "Python",
  "Ruby on Rails",
  "Django",
  "Flask",
  "React",
  "React Native",
  "Node.js",
  "Docker",
  "Testing",
  "AWS",
  "CI/CD",
];

